import React from "react";
import EmptyState from "../shared/EmptyState";
import SeminarForm from "./SeminarForm";
import AddButton from "../shared/AddButton";
import { RelatedSeminarsSectionProps } from "./types";

const RelatedSeminarsSection = ({
    selectedSeminars = [],
    seminarList = [],
    sessionsList = [],
    state,
    onSeminarChange,
    onSessionChange,
    onRemoveSeminar,
    onAddSeminar,
    getFilteredOptionsForSection
}: RelatedSeminarsSectionProps) => {
    return (
        <>
            {(!selectedSeminars || selectedSeminars.length === 0) && (
                <EmptyState
                    title="Related Seminars & Sessions"
                    label="Seminar Name"
                    name="seminarName"
                    options={seminarList.map((seminar) => ({ 
                        label: seminar.event.eventTitle, 
                        value: seminar.event.eventTitle 
                    }))}
                    value={state.seminarName || ""}
                    onChange={(name, value) => onSeminarChange(value)}
                />
            )}

            {(selectedSeminars && selectedSeminars.length > 0) &&
                selectedSeminars.map((seminar, index) => (
                    <SeminarForm
                        key={`${seminar._id || "seminar"}-${index}`}
                        seminar={seminar}
                        index={index}
                        state={state}
                        sessionsList={sessionsList}
                        onSeminarChange={onSeminarChange}
                        onSessionChange={onSessionChange}
                        onRemoveSeminar={onRemoveSeminar}
                        getFilteredOptionsForSection={getFilteredOptionsForSection}
                    />
                ))}
            
            <AddButton onAdd={onAddSeminar} label="Add Seminar" />
        </>
    );
};

export default RelatedSeminarsSection;
